"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const emptyData = {
    name: '',
    logo: '',
    color: '',
    image: '',
};
class Crop {
    constructor(data = emptyData) {
        this.name = data.name || '';
        this.logo = data.logo || '';
        this.color = data.color || '';
        this.image = data.image || '';
    }
    get src() {
        var _a;
        return (_a = this.image) !== null && _a !== void 0 ? _a : `/crop/pic/white/${this.logo}/Soil`;
    }
}
exports.default = Crop;
